import { createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api_service';
import { datasetsAndLabels } from '../../utils/datasetsAndLabels';

export const fetchChartData = createAsyncThunk(
  'chart/fetchChartData',
  async ({ chartId, x_axis, y_axis }, { getState, rejectWithValue }) => {
    try {
      const { importFileName } = getState().segmenter;
      const data = await apiService.fetchChartResponse2({
        x_axis,
        y_axis,
        input_file: importFileName,
      });
      if (data) {
        const plotData = data.plot_data;
        const { selectedX, chartType } = getState().chart.charts?.[chartId] || {};
        const { xGrouped, yGrouped } = datasetsAndLabels(plotData, chartType, selectedX);
        return {
          aggregatedData: { labels: xGrouped, datasets: yGrouped },
          data: { labels: xGrouped, datasets: yGrouped },
        };
      } else {
        return rejectWithValue('Failed to fetch response.');
      }
    } catch (error) {
      return rejectWithValue('Error fetching response.');
    }
  }
);